import MetaMaskOnboarding from '@metamask/onboarding';
import React from 'react';
import styled, {css} from "styled-components";
import metamask from "../assets/metamask.svg"


const ConnectBtn = styled.button`
  background: transparent;
  margin:2rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  color:#6e306b;
  font-family: 'PT Sans Narrow', sans-serif;
  text-transform: uppercase;
  margin:0 2rem;
  border: 2px solid #6e306b;
  min-width: 140px;
  min-height: 40px;
  border-radius: 5px;
  transition: .1s all ease-in-out;

  
  img {
  margin:0 1rem;
  width: 30px;
  height: 30px;
  }
  
  
  &:hover {
    cursor: pointer;
     border: 2px solid #fff;
     color:#fff;
    transition: .1s all ease-in-out;
  }
  
  &:focus {
  outline: none;
  }
  
  
  
   ${({secondary}) =>
    secondary && css`
     border: 2px solid #fff;
       color:#fff;
    margin-top: 2rem;

  &:hover {
    cursor: pointer;
     border: 2px solid #6e306b;
     color:#fff;
    transition: .1s all ease-in-out;
  }
    `
}
`

const CONNECT_TEXT = 'Connect';
const CONNECTED_TEXT = 'Connected';

export function Connect({secondary}) {
    const [buttonText, setButtonText] = React.useState(CONNECT_TEXT);
    const [isDisabled, setDisabled] = React.useState(false);
    const [accounts, setAccounts] = React.useState([]);

    const onboarding = React.useRef();
    // const { setMetamaskInstalled } = useContext(WindowContext)

    React.useEffect(() => {
        if (!onboarding.current) {
            onboarding.current = new MetaMaskOnboarding();
        }
    }, []);

    React.useEffect(() => {
        if (MetaMaskOnboarding.isMetaMaskInstalled()) {
            if (accounts.length > 0) {
                // setMetamaskInstalled(true)
                setButtonText(CONNECTED_TEXT);
                setDisabled(true);
                onboarding.current.stopOnboarding();
            } else {
                setButtonText(CONNECT_TEXT);
                setDisabled(false);
            }
        }
    }, [accounts]);

    const connectWallet = () => {
        function handleNewAccounts(newAccounts) {
            setAccounts(newAccounts);
        }
        if (MetaMaskOnboarding.isMetaMaskInstalled()) {

            window.ethereum
                .request({ method: 'eth_requestAccounts' })
                .then(handleNewAccounts);
            window.ethereum.on('accountsChanged', handleNewAccounts);
            return () => {
                window.ethereum.off('accountsChanged', handleNewAccounts);
            };
        }
    }




    const onClick = () => {

        connectWallet()
        if (MetaMaskOnboarding.isMetaMaskInstalled()) {
            window.ethereum
                .request({ method: 'eth_requestAccounts' })
                .then((newAccounts) => setAccounts(newAccounts));
        } else {
            onboarding.current.startOnboarding();
        }
    };

    return (
        <ConnectBtn disabled={isDisabled} isConnected={isDisabled} secondary={secondary} onClick={onClick}> Connect </ConnectBtn>
    );
}


